import React, { useEffect, useState } from 'react';

import { useFormikContext } from 'formik';

function MonthlyTotal({ typeView, template }) {
  const [totalMonthly, setTotalMonthly] = useState(0);
  const [totalAnnual, setTotalAnnual] = useState(0);

  const [totalMonthlyCurrency, setTotalMonthlyCurrency] = useState({});
  const [totalAnnualCurrency, setTotalAnnualCurrency] = useState({});

  const isFree = template?.is_free;

  const {
    values: {
      employees_covered,
      price_employee_month,
      price_session,
      monthly_discount_enable,
      monthly_discount,
      annual_discount,
      monthly_custom_records,
      payment_mode,
      rules,
      currency_prices,
      billing_duration_month,
      is_pay_per_used,
      sessions,
    },
    touched,
  } = useFormikContext();

  useEffect(() => {
    let totalMonthly = 0;
    let totalAnnual = 0;

    const monthlyCurrency = {};
    const annualCurrency = {};

    if (employees_covered != undefined && employees_covered != '') {
      totalMonthly = employees_covered * price_employee_month;
      if (is_pay_per_used) {
        totalMonthly = 0;
      }
      if (typeView == 'template') {
        currency_prices.forEach((currencyPrice) => {
          if (monthlyCurrency[currencyPrice.currency] === undefined) {
            monthlyCurrency[currencyPrice.currency] = 0;
            annualCurrency[currencyPrice.currency] = 0;
          }
          monthlyCurrency[currencyPrice.currency] = employees_covered * currencyPrice.price;
          annualCurrency[currencyPrice.currency] = monthlyCurrency[currencyPrice.currency] * 12;
        });
      }
    }

    if (rules) {
      rules.forEach((rule) => {
        if (rule.type === 'price_minimal' && !isFree) {
          if (typeView === 'policy') {
            const minimalPrice = template.currency.title === 'USD' ? 100 : 135;
            if (totalMonthly < minimalPrice) {
              totalMonthly = minimalPrice;
            }
          }
          if (typeView === 'template') {
            for (const [currency, price] of Object.entries(monthlyCurrency)) {
              const minimalPrice = currency === 'USD' ? 100 : 135;
              if (price < minimalPrice) {
                monthlyCurrency[currency] = minimalPrice;
                annualCurrency[currency] = minimalPrice * 12;
              }
            }
          }
        }
      });
    }

    monthly_custom_records.forEach((item) => {
      const price = Number(item.price);

      totalMonthly += price;

      if (typeView == 'template') {
        item.currency_prices.forEach((currencyPrice) => {
          if (monthlyCurrency[currencyPrice.currency] === undefined) {
            monthlyCurrency[currencyPrice.currency] = 0;
            annualCurrency[currencyPrice.currency] = 0;
          }
          monthlyCurrency[currencyPrice.currency] += Number(currencyPrice.price);
          annualCurrency[currencyPrice.currency] += Number(currencyPrice.price * 12);
        });
      }
    });
    if (monthly_discount_enable && monthly_discount != '') {
      const discount = (100 - Number(monthly_discount)) / 100;
      totalMonthly *= discount;

      if (typeView == 'template') {
        for (const [currency, price] of Object.entries(monthlyCurrency)) {
          monthlyCurrency[currency] *= discount;
          annualCurrency[currency] *= discount;
        }
      }
    }

    totalAnnual = totalMonthly.toFixed(2) * billing_duration_month;

    if (annual_discount != '') {
      const annualDiscount = (100 - Number(annual_discount)) / 100;
      totalAnnual *= annualDiscount;

      if (typeView == 'template') {
        for (const [currency, price] of Object.entries(monthlyCurrency)) {
          annualCurrency[currency] *= annualDiscount;
        }
      }
    }

    if (is_pay_per_used) {
      totalMonthly += employees_covered * price_session * sessions;
      totalAnnual += employees_covered * price_session * sessions * billing_duration_month;
    }

    setTotalMonthly(totalMonthly.toFixed(2));
    setTotalAnnual(totalAnnual.toFixed(2));

    setTotalMonthlyCurrency(monthlyCurrency);
    setTotalAnnualCurrency(annualCurrency);
  }, [
    employees_covered,
    price_employee_month,
    monthly_discount_enable,
    monthly_discount,
    annual_discount,
    monthly_custom_records,
    payment_mode,
    currency_prices,
    is_pay_per_used,
    price_session,
    sessions,
    touched.employees_covered,
    touched.price_employee_month,
    touched.monthly_discount_enable,
    touched.monthly_discount,
    touched.monthly_custom_records,
    touched.payment_mode,
    touched.annual_discount,
    touched.currency_prices,
    touched.is_pay_per_used,
    touched.price_session,
  ]);

  return (
    <h2>
      {typeView == 'policy' && (
      <div>
        {payment_mode ? 'Annual' : 'Monthly'}
        {' '}
        Premium Total:
        {' '}
        {template.currency.mark}
        {payment_mode ? totalAnnual : totalMonthly}
        {' '}
        {template.currency.title}
      </div>
      )}
      {typeView == 'template' && (
      <>
        <div>
          Monthly Premium Total:
          <ul>
            {Object.entries(totalMonthlyCurrency).map((item) => (
              <li>{`${item[0]}:${Math.round(item[1] * 100) / 100}`}</li>
            ))}
          </ul>
        </div>
        <div>
          Annual Premium Total:
          <ul>
            {Object.entries(totalAnnualCurrency).map((item) => (
              <li key={item[0]}>{`${item[0]}:${Math.round(item[1] * 100) / 100}`}</li>
            ))}
          </ul>
        </div>
      </>
      )}
    </h2>
  );
}

export default MonthlyTotal;
